export default {
  "meeting": {
    applyrecurring: 'تغییرات روی برنامه تکرارشونده جدید اعمال می‌شود و جلسات گذشته بدون تغییر باقی می‌مانند.',

    recurrenceDescribeTwo: 'هر {loopPulse} هفته در {week} از {start} تا {end} تکرار می‌شود',
    wanttodeletethemeetingfollowTwo: 'آیا می‌خواهید جلسه انتخاب‌شده و تمام جلسات تکرارشونده بعدی حذف شوند؟',
    loopCycleSelectTips: 'لطفاً روز هفته را برای تکرار انتخاب کنید.',

    export: 'صادر کردن',
    exportMeetingFileFuncTipsTitle: 'تأیید صادرات',
    exportMeetingFileFuncTipsContentOne: 'هیچ فیلتری اعمال نشده است. سیستم به‌طور پیش‌فرض سوابق جلسات سال جاری را صادر می‌کند.',
    exportMeetingFileFuncTipsContentTwo: 'برای صادرات جلسات در بازه زمانی دیگر، لطفاً قبل از صادرات فیلترهای موردنظر را اعمال کنید.',


    myMeetingSearch: 'جلسات من',
    meetingTimeSearch: 'زمان جلسه',
    meetingRoomsSearch: 'اتاق جلسه',

    Recurring: 'تکرار:',
    wanttodeletethemeetingfollow: 'آیا مطمئن هستید که می‌خواهید این جلسه و تمام جلسات بعدی را حذف کنید؟',
    endTimeCannotBeforeBeginTime: 'تاریخ پایان نمی‌تواند قبل از تاریخ شروع باشد',
    Thismeeting: 'این جلسه',
    Recurringmeeting: 'جلسه تکرارشونده',
    Checkin: 'ورود:',
    checkinTip: 'پس از فعال‌سازی، شرکت‌کنندگان می‌توانند با اسکن کد QR زمان‌بندی اتاق، ورود خود را ثبت کنند.',
    Recurrence_Setrecurrence: 'تنظیم تکرار',
    Recurrence_Start: 'شروع',
    Recurrence_RepeatEvery: 'تکرار هر',
    Recurrence_Week: 'هفته',
    Recurrence_end: 'پایان',
    recurrenceDescribe: 'هر {week} یک‌بار از {start} تا {end} تکرار می‌شود',
    Recurrence_DoesnotRepeat: 'تکرار نشود',
    Recurrence_Weekly: 'هفتگی',

    AddressBookUser: 'کاربر',
    AddressBookPhonebook: 'دفترچه مخاطبین',

    RoomByPeopleNum1: '۲ نفر یا کمتر',
    RoomByPeopleNum2: '۳-۶ نفر',
    RoomByPeopleNum3: '۷-۱۰ نفر',
    RoomByPeopleNum4: '۱۱-۱۵ نفر',
    RoomByPeopleNum5: '۱۶-۲۰ نفر',
    RoomByPeopleNum6: '۲۱-۳۰ نفر',
    RoomByPeopleNum7: 'بیش از ۳۰ نفر',

    whoAreBound: 'کاربرانی که به حساب سیستم متصل هستند، جلسه را در تقویم سیستم مشاهده خواهند کرد. کاربرانی که ایمیل وارد کرده‌اند، اعلان‌ها را از طریق ایمیل دریافت می‌کنند. برای دریافت اعلان‌ها، اطلاعات خود را در [پروفایل من] تکمیل کنید.',

    AttendessMeeting: 'شرکت‌کنندگان:',
    SelectAttendessMeetingTip: 'انتخاب شرکت‌کنندگان',

    MeetingFilter: 'فیلتر جلسات',
    HostedbyMe: 'من برگزارکننده',
    Invitedby: 'من شرکت‌کننده',
    Otherby: 'سایر',

    "AddressIsDuplicated": "ایمیل مخاطب تکراری است",
    "meetingExpired": "منقضی شده",
    titlePhoneFormat: 'تلفن فقط می‌تواند شامل اعداد، () + و - باشد.',
    "selectField": "لطفاً یک فایل انتخاب کنید",
    "Limit255": "نام فایل نمی‌تواند بیش از ۲۵۵ کاراکتر باشد",
    "nameLimit25": "نام نمی‌تواند بیش از ۲۵ کاراکتر باشد",
    "emailLimit50": "ایمیل نمی‌تواند بیش از ۵۰ کاراکتر باشد",
    "emailFormatError": "لطفاً یک ایمیل معتبر وارد کنید",
    "phoneLimit11": "شماره تلفن می‌تواند تا ۱۱ رقم باشد",
    "ParticipantsEmail": "ایمیل شرکت‌کننده:",
    "listIsEmpty": "لیست خالی است",
    "Startimporting": "شروع بارگذاری",
    "Selectfile": "انتخاب فایل",
    "Importfile": "وارد کردن فایل",
    "ImportfileTip": "*فقط فایل‌های CSV با فرمت Outlook (.csv) یا فایل‌های vCard (.vcf) برای وارد کردن پشتیبانی می‌شوند.",
    "addParticipants": "افزودن شرکت‌کننده",
    "multiselectdeselect": "راهنمای حذف برچسب",
    "multiselectselected": "راهنمای انتخاب شده",
    "enterOrSelectALabel": "ایمیل شرکت‌کننده را انتخاب کنید",
    "deleTitleContact": "آیا مطمئن هستید که می‌خواهید این مخاطب را حذف کنید؟",
    "delTitleContactContent": "حذف مخاطب؟",
    "deleteContactTitle": "لطفاً مخاطب مورد نظر برای حذف را انتخاب کنید",
    "editcontact": "ویرایش مخاطب",
    "Name": "نام",
    "email": "ایمیل",
    "telephoneNumber": "تلفن",
    "Addcontact": "افزودن مخاطب",
    "Importcontactfile": "وارد کردن مخاطبین",
    "AddressBook": "دفترچه آدرس",
    "Participants": "شرکت‌کنندگان:",

    bindTipContent:"این سازمان قبلاً یک تقویم شخص ثالث را متصل کرده است. لطفاً جلسات را از طریق Outlook/Teams برنامه‌ریزی کنید.",
    Productupdatenews: '‌روزرسانی نسخه جدید منتشر شد.',
    bookingPerson: 'رزرو شده توسط',
    "DeleteMeeting": "حذف جلسه",
    "wanttodeletethemeeting": "آیا می‌خواهید جلسه را حذف کنید؟",
    "hasbeendeleted": "جلسه حذف شد",
    "theMeetingWasAborted": "پایان جلسه زودتر از موعد",
    "theMeetingWasAbortedContent": "آیا می‌خواهید جلسه را زودتر به پایان برسانید؟",
    "determineTheAbortTask": "پایان جلسه زودتر از موعد",
    "theMeetingEndedEarly": "جلسه زودتر از موعد به پایان رسید.",
    "with": "با",
    "Other": "با",
    "tasks": "وظایف دیگر",
    "conflict": "تداخل دارند",
    "meetConflicts": "زمان جلسه زیر تداخل دارد:",
    "itIsNotAllowedToSelectThePastTime": "زمان‌های گذشته قابل انتخاب نیستند",
    "selected": "انتخاب شده",
    "noOverFive": "حداکثر ۵ اتاق جلسه باید انتخاب شوند",
    "approvalOpinions": "نظرات تایید",
    "beyondTheTimeLimitItCannotBeSelected": "فراتر از زمان محدود نمی‌توان انتخاب کرد",
    "startMonth": "ماه شروع",
    "to": "تا",
    "stopMonth": "پایان ماه",
    "didnTStart": "شروع ندارد",
    "ONGOING": "در جریان",
    "ENDED": "تمام شده",
    "hasBeen": "انجام شده",
    "booking": "رزرو",
    "Approval": "تأیید",
    "MeetingRoom": "اتاق جلسه",
    "AllRoom": "تمام اتاق‌ها",
    "Available": "در دسترس",
    "Initiate": "شروع جلسه",
    "MeetingApproval": "تأیید جلسه",
    "PreviousMonth": "ماه گذشته",
    "Today": "امروز",
    "NextMonth": "ماه آینده",
    "YearMonth": "سال/ماه",
    "TimeDisplay": "نمایش زمان",
    "MeetingTitleAbbreviation": "اختصار عنوان جلسه",
    "InitiateMeeting": "شروع جلسه",
    "PendingMeetings": "جلسات آینده",
    "AllMeetings": "تمام جلسات",
    "noMeetings": "در حال حاضر جلسه‌ای برای حضور وجود ندارد",
    "NotStarted": "شروع نشده",
    "Organizer": "سازمان‌دهنده",
    "MeetingDateTime": "تاریخ و زمان",
    "MeetingLocation": "مکان",
    "MeetingSubject": "موضوع جلسه",
    "Invited": "دعوت‌شدگان",
    "PeopleAccepted": "افرادی که پذیرفته‌اند",
    "EditMeeting": "ویرایش جلسه",
    "CancelMeeting": "لغو جلسه",
    "InitiateEditMeeting": "شروع/ویرایش جلسه",
    "Subject": "موضوع",
    "Presenter": "ارائه‌دهنده:",
    "DateTime": "تاریخ و زمان",
    "TimeAndZone": "منطقه زمانی",
    "Attendees": "شرکت‌کنندگان",
    "Addrequiredattendees": "اضافه کردن شرکت‌کنندگان مورد نیاز",
    "SelectRooms": "انتخاب اتاق‌ها",
    "Reminder": "یادآور",
    "Remindbeforestart": "یادآوری قبل از شروع",
    "Confirm": "تأیید",
    "topic": "موضوع:",
    "topicplace": "عنوان جلسه جدید:",
    "speaker": "ارائه‌دهنده:",
    "speakerplace": "لطفاً اطلاعات ارائه‌دهنده را وارد کنید",
    "DateAndTime": "تاریخ و زمان:",
    "TimeZone": "منطقه زمانی",
    "EndDate": "تاریخ پایان",
    "Rooms": "اتاق‌ها:",
    "Notes": "یادداشت‌ها:",
    "MeetingRoomApproval": "تأیید اتاق جلسه",
    "PendingApproval": "در انتظار تأیید",
    "Approved": "تأیید شده",
    "nopendingapprovals": "هیچ تأیید معلقی وجود ندارد",
    "Applicant": "درخواست‌کننده",
    "UsageTime": "زمان استفاده",
    "ApprovalResult": "نتیجه تأیید",
    "ApprovalComments": "توضیحات تأیید",
    "Approve": "تأیید",
    "Reject": "رد",
    "Search": "جستجو",
    "Filter": "فیلتر",
    "scanTheQRCodeToSignIn": "کد QR را اسکن کنید تا وارد شوید"
  },
  "NPS": {
    "Relay": "رله",
    "RelaySettings": "تنظیمات رله",
    "DevicePower": "کنترل قدرت دستگاه",
    "DeviceElevation": "کنترل ارتفاع",
    "LinageWithNPSPower": "اتصال به تأمین برق NPS",
    "PresentationSwitch": "کلید تغییر ارائه",
    "Duplicate": "تکرار",
    "LinkagewithNPSPowe": "اتصال به تأمین برق NPS",
    "npsTooltip": "دستگاه‌های USB فقط می‌توانند توسط میزبان رایانه شخصی که به HDMI OUT 1 تنظیم شده است، فراخوانی شوند.",
    "nmpTooltip": "روی دکمه «تکرار» کلیک کنید تا محتوای صفحه روی نمایشگرهای دیگر آینه شود و نمایشگرها همزمان با یکدیگر نمایش داده شوند."
  },
  "textTemplate": {
    "template2513": "پخش اضطراری آتش‌سوزی",
    "template2514": "لطفاً طبق طرح فرار از آتش از خروجی اضطراری و خروجی آتش به مکان امن تخلیه شوید.",
    "moreTemplate": "حد قالب رسید",
    "add": "اضافه کردن",
    "SetTemplate": "تنظیم قالب",
    "Emergency": "اضطراری",
    "General": "عمومی",
    "BroadcastDevices": "دستگاه پخش:",
    "selectBroadcastDevices": "لطفاً دستگاه‌های پخش را انتخاب کنید",
    "All": "همه",
    "AddTemplate": "اضافه کردن قالب",
    "EditTemplate": "ویرایش قالب",
    "deleteTemplage": "آیا مطمئن هستید که می‌خواهید قالب انتخابی را حذف کنید؟",
    "title": "حذف قالب",
    "selectTemplage": "لطفاً قالبی را انتخاب کنید!",
    "DeleteCancelled": "حذف لغو شد!",
    "DeletedSuccessfully": "حذف با موفقیت انجام شد!",
    "noData": "هیچ قالبی برای استفاده وجود ندارد، روی گوشه بالا سمت راست کلیک کنید تا یک قالب اضافه کنید.",
    "TemplateTitle": "عنوان قالب:",
    "BroadcastType": "نوع پخش:",
    "BroadcastTypeDialog": "نوع پخش:",
    "selectBroadcastType": "لطفاً نوع پخش را انتخاب کنید",
    "BroadcastDuration": "مدت زمان پخش:",
    "BroadcastDevice": "دستگاه پخش:",
    "BroadcastContent": "محتوای پخش:"
  },
  "common": {
    "mediaTimeStateNotifyErrorTitle": "خطا!",
    "mediaTimeStateNotifyErrorContent": "سرویس پخش شما منقضی شده است، لطفاً با نماینده خود تماس بگیرید تا آن را به موقع تمدید کند.",
    "mediaTimeStateNotifyWarnTitle": "توجه!",
    "mediaTimeStateNotifyWarnContent": "شما در حال حاضر در حالت آزمایشی هستید که فقط می‌تواند پخش و استریم زنده را به حداکثر ۳ دستگاه پایانی ارسال کند.",
    "mediaTimeStateNotifySuccessTitle": "تمدید موفق",
    "mediaTimeStateNotifySuccessContent": "سرویس پخش شما آماده استفاده معمولی است. متشکریم.",
    "company": "نام شرکت:",
    "tableAddress": "آدرس:",
    "createTime": "زمان ایجاد:",
    "email": "ایمیل:",
    "phone": "تلفن:",
    "Trial": "آزمایشی",
    "TrialWorkstation": "شما در حال حاضر در حالت آزمایشی هستید که فقط می‌تواند پخش و استریم زنده را به حداکثر ۳ دستگاه پایانی ارسال کند.",
    "Normal": "معمولی",
    "NormalWorkstation": "دوره اعتبار سرویس پخش شما از ",
    "to": "تا ",
    "Advent": "آدونت",
    "AdventWorkstationOne": "سرویس پخش شما در تاریخ ",
    "AdventWorkstationTwo": "منقضی خواهد شد، لطفاً با نماینده خود تماس بگیرید تا آن را به موقع تمدید کند تا بتوانید از آن به طور معمول استفاده کنید.",
    "Expired": "منقضی شده",
    "ExpiredWorkstation": "سرویس پخش شما منقضی شده است، لطفاً با نماینده خود تماس بگیرید تا آن را به موقع تمدید کند."
  },
  "route": {
    "dashboard": "داشبورد",
    "i18n": "I18n",
    "Devices": "دستگاه‌ها",
    "Broadcast": "پخش",
    "Schedule": "برنامه",
    "Resources": "منابع",
    "Live": "زنده",
    "meetings": "جلسات"
  },
  "navbar": {
    "updates":"آخرین به‌روزرسانی‌ها",
    "logOut": "خروج از حساب",
    "screenfull": "تمام صفحه",
    "oprofile": "پروفایل من",
    "settings": "تنظیمات",
    "language": "زبان",
    "BackTianwa": "بازگشت به Tianwa",
    "newUserGuide": "راهنمای کاربر جدید"
  },
  "feedback": {
    "Feedback": "بازخورد",
    "email": "لطفاً ایمیل خود را برای دریافت بازخورد بگذارید.",
    "content": "خوش آمدید و پیام‌هایی برای بهبود محصولات ما بگذارید. از نظرات شما سپاسگزاریم.",
    "submit": "ارسال",
    "emailNoEmpty": "ایمیل نمی‌تواند خالی باشد",
    "emailTrueRule": "لطفاً فرمت ایمیل صحیح را وارد کنید",
    "contentNoEmpty": "محتوا نمی‌تواند خالی باشد",
    "feedbackSuccess": "بازخورد موفق",
    "feedbackFailed": "بازخورد ناموفق",
    "emailNoChinese": "پست الکترونیکی نمی‌تواند حاوی کاراکترهای چینی باشد",
    "emailLength": "طول آن باید بین ۵ تا ۵۰ کاراکتر باشد",
    "emailSpecialString": "پست الکترونیکی نمی‌تواند شامل رشته‌های خاص باشد"
  },
  "login": {
    checkPasswordTitleTwo: 'لطفاً یک رمز عبور حداقل ۶ کاراکتری شامل حروف و اعداد تنظیم کنید. استفاده از کاراکترهای خاص مجاز است (بدون محدودیت).',
    captcha: 'کد تأیید',
    checkPasswordTitle: 'رمز عبور باید حداقل ۶ کاراکتر داشته باشد و نمی‌تواند فقط شامل اعداد باشد',
    "title": "خوش آمدید",
    "logIn": "ورود به سیستم",
    "consoleLogin": "ورود به کنسول",
    "username": "نام کاربری",
    "password": "رمز عبور",
    "any": "هر",
    "thirdparty": "یا اتصال از طریق",
    "thirdpartyTips": "در محلی شبیه‌سازی نمی‌شود، بنابراین لطفاً شبیه‌سازی کسب‌وکار خود را ترکیب کنید! ! !",
    "placeholder": "[\n  \"نام کاربری\",\n  \"رمز عبور\",\n  \"کد تأیید\"\n]",
    "userNameTitle": "نام کاربری اشتباه است!",
    "forget": "فراموش کرده‌اید؟",
    "loginTitle0": "ورود موفقیت‌آمیز!",
    "loginTitle1000": "نام کاربری یا رمز عبور اشتباه است!",
    "loginTitle1001": "نام کاربری و رمز عبور باید پر شوند!",
    "loginTitle1002": "کد تأیید باید پر شود!",
    "loginTitle1003": "وضعیت کاربر غیرقانونی است، ورود ناموفق!",
    "loginTitle1004": "خطای کد تأیید!",
    "loginTitle1005": "ورود نکرده‌اید، لطفاً ابتدا وارد شوید!",
    "loginTitle1006": "دو رمز عبور متفاوت است!",
    "loginTitleUserName": "نام کاربری باید پر شود!",
    "loginTitlePwd": "رمز عبور باید پر شود!",
    "loginTitleVercode": "کد تأیید باید پر شود!",
    "titleLoginNameFormat": "حساب باید از کاراکترها یا کاراکترها و اعداد تشکیل شده باشد.",
    "privacy": "Q-NEX User Privacy Policy",
    "privacyContent": "Agree to",
    "_zh": "中文(简体)",
    "_en": "_English",
    "_ko": "한국어",
    "_zh_ft": "中文(繁體)"
  },
  "home": {
    "btnDevices": "دستگاه‌ها",
    "btnRoadcast": "پخش",
    "btnResources": "منابع",
    "btnLive": "استریم",
    "meetings": "جلسه",
    "todaySchedule": "زمان‌بندی امروز",
    "allSkedules": "تمام زمان‌بندی‌ها",
    "details": "جزئیات",
    "btnStart": "شروع",
    "titleContent": "خوش آمدید! کنسول Q-NEX در خدمت شماست. بیایید شروع کنیم!",
    "btnExit": "خروج"
  },
  "devices": {
    ptzCamera:'دوربین PTZ',
    "start": "شروع",
    "stop": "توقف",
    "nmpPowerOff_mandatory": "در حال پخش (غیر اجباری)",
    "nmpPowerOff_nomandatory": "در حال پخش (غیر اجباری). آیا ادامه اجرا را می‌خواهید؟",
    "nmpsPowerOff_mandatory": "برخی از NMPها در حال پخش (اجباری) هستند.",
    "nmpsPowerOff_nomandatory": "برخی از NMPها در حال پخش (غیر اجباری) هستند. آیا ادامه اجرا را می‌خواهید؟",
    "reset": "بازنشانی",
    "displayedInTheControlArea": "در مرکز کنترل نمایش داده شده است",
    "dragOrder": "ترتیب کشیدن",
    "areaSettingTwoNotice": "*کنترل RS232، کنترل AC و کنترل از راه دور بسته به وضعیت اتصال NMP در داشبورد در مرکز کنترل نمایش داده می‌شود.",
    "areaSettingThreeNotice": "*کنترل CBX بسته به وضعیت اتصال NMP در داشبورد در مرکز کنترل نمایش داده می‌شود.",
    "controlSet": "تنظیمات مرکز کنترل",
    "vcbNoLine": "هیچ دستگاه CBX آنلاین نیست",
    "vcbNoBound": "هیچ دستگاه CBX متصل نیست",
    "tscNoBound": "RS232 در TSC به هیچ داده‌ای متصل نیست. لطفاً به مدیر اطلاع دهید تا آن را در داشبورد متصل کند.",
    "light": "کنترل برق",
    "vcbpower": "برق",
    "rs232Control": "کنترل سریال",

  "CBX": {
    "powerSupplyON": "روشن",
    "powerSupplyOFF": "خاموش",
    "lockScreenON": "قفل روشن",
    "lockScreenOFF": "قفل خاموش",
    "childLockON": "قفل کودک روشن",
    "childLockOFF": "قفل کودک خاموش",
    "energySavingON": "صرفه‌جویی در انرژی روشن",
    "energySavingOFF": "صرفه‌جویی در انرژی خاموش",
    "signalSourceSwitchingON": "OPS",
    "signalSourceSwitchingOFF": "اندروید",
    "volumeAdjustment": "بلندگو",
    "brightAdjustment": "روشنایی",
    "other": "ویژگی‌های دیگر..."
  },

    "InterfaceOne": "رابطه اول",
    "InterfaceTwo": "رابطه دوم",
    "abcStyleP": "ببخشید! TSC و (NMP, MBX, NPS, NDP100, NDP500) نمی‌توانند همزمان انتخاب شوند",
    "masterControl": "اصلی",
    "powerSupply": "قدرت",
    "RecordingControl": "کنترل ضبط",
    "RecordingControlSystem": "سیستم ضبط سخنرانی",
    "LiquidCrystal": "نمایشگر LCD تعاملی",
    "projector": "پروژکتور",
    "othertype": "سایر",
    "lockScreen": "قفل",
    "childLock": "قفل کودک",
    "energySaving": "صرفه‌جویی در انرژی",
    "signalSourceSwitching": "منبع ورودی",
    "volumeAdjustment": "بلندگو",
    "brightAdjustment": "درخشندگی",
    "other": "ویژگی‌های دیگر",
    "otherFunction": "عملکرد",
    "send": "ارسال",
    "ON": "ON",
    "OFF": "OFF",
    "_POWERA": "Display Power",
    "_POWERB": "External Power",
    "_MAGNETICLOCK": "MAGNETICLOCK",
    "_HDMI1": "HDMI in 1",
    "_HDMI2": "HDMI in 2",
    "_HDMI3": "HDMI in 3",
    "_HDMIA": "HDMI out A",
    "_HDMIB": "HDMI out B",
    "_HDMIC": "HDMI out C",
    "_AIR": "کولر گازی",
    "titleDevices": "فیلتر گروه‌ها:",
    "content": "جستجو",
    "selectALL": "انتخاب همه",
    "SelectRecentPage": "انتخاب صفحه فعلی",
    "controlPanel": "مرکز کنترل",
    "displayInputSwitch": "سوئیچ ورودی نمایشگر",
    "chooseINPUTSources": "انتخاب منابع ورودی",
    "speakerVolume": "حجم صدا",
    "bass": "بیس",
    "treble": "تریبل",
    "MICVolume": "حجم میکروفن",
    "AirConditioning": "کولر گازی",
    "model": "مدل",
    "setTemp": "دمای تنظیمی",
    "fanSpeed": "سرعت فن",
    "bold": "چرخش",
    "projectionScreen": "صفحه نمایش پروژکتور",
    "electronicLock": "قفل الکتریکی",
    "electronicLock1": "قفل الکتریکی",
    "selectDevices": "لطفاً یک دستگاه یا گروهی از دستگاه‌ها را انتخاب کنید",
    "isCompelType": "کنترل دستگاه غیرقابل دسترس به دلیل پخش اجباری، لطفاً بعداً دوباره تلاش کنید.",
    "mainPower": "قدرت اصلی",
    "extraPower": "قدرت اضافی",
    "power": "قدرت",
    "hdmiBroadcast": "پخش",
    "equipmentState1": "روشن شدن",
    "equipmentState2": "خاموش شدن",
    "equipmentState3": "آفلاین",
    "main": "اصلی",
    "external": "خارجی",
    "ProjectionScreen": "صفحه نمایش پروژکتور",
    "UP": "بالا",
    "DOWN": "پایین",
    "LOCK": "قفل",
    "UNLOCK": "آزاد",
    "PleaseDevice": "لطفاً دستگاه‌ها را از سمت چپ انتخاب کنید",
    "RemoteControl": "کنترل از راه دور",
    "Action": "عملیات",
    "Devicefilter": "فیلتر دستگاه",
    "DeviceStatus": "وضعیت",
    "DeviceType": "نوع",
    "currentAudioSource": "منبع صدای فعلی",
    "audioSwitching": "سوئیچ خروجی صدا"
  },
  "broadcast": {
    "isBoarding": "(در حال پخش)",
    "last3Days": "آخرین 3 روز",
    "last7Days": "آخرین 7 روز",
    "last30Days": "آخرین 30 روز",
    "historyRecord": "تاریخچه",
    "SelectDestination": "1. مقصد را انتخاب کنید",
    "BroadcastingConsole": "2. کنسول پخش",
    "Notification": "اعلان",
    "btnStop": "توقف",
    "btnStart": "شروع",
    "Letters60": "(کمتر از 60 حرف)",
    "Letters300": "(کمتر از 300 حرف)",
    "LastingTime": "زمان پخش:",
    "Title": "عنوان:",
    "Content": "محتوا:",
    "Cannotquit": "پخش اجباری",
    "ChooseMedia": "یک فایل رسانه‌ای انتخاب کنید",
    "Broadcasting": "پخش",
    "dialogTitle": "منابع ویدئو و صدا",
    "SortBy": "مرتب‌سازی بر اساس",
    "btnBake": "بازگشت به صفحه قبلی",
    "cancel": "لغو",
    "confirm": "تأیید",
    "save": "ذخیره",
    "coxAll": "همه",
    "PublicCloud": "ذخیره‌سازی عمومی",
    "IndividualCloud": "ذخیره‌سازی شخصی",
    "selFile": "لطفاً یک فایل یا یک گروه انتخاب کنید.",
    "StopBroadcast": "توقف پخش",
    "StartBroadcasting": "شروع پخش",
    "StopBroadcasting": "توقف پخش",
    "ForceQuit": "خروج اجباری",
    "PleaseMediaFile": "لطفاً یک فایل رسانه‌ای انتخاب کنید",
    "PleaseDevice": "لطفاً یک دستگاه انتخاب کنید",
    "broadcast_0": "شروع پخش",
    "broadcast_2500": "تعداد دستگاه‌های قابل اتصال به سرور رسانه‌ای بیشتر از حد مجاز است",
    "broadcast_2501": "خطای فایل پخش",
    "broadcast_2502": "پخش پایان یافت",
    "broadcast_2503": "امکان دریافت اطلاعات سرور رسانه‌ای وجود ندارد",
    "broadcast_2510": "توجه! شما در حال حاضر در حالت آزمایشی هستید، حداکثر 3 دستگاه می‌توانند دستورات پخش را دریافت کنند، لطفاً تعداد دستگاه‌های انتخابی خود را بررسی کنید.",
    "broadcast_2018": "سرویس استریم غیرفعال است",
    "broadcast_2019": "سرویس استریم منقضی شده است",
    "broadcast_2512": "تعداد قالب‌ها بیشتر از حد مجاز است.",
    "broadcast_2513": "پخش اضطراری آتش‌سوزی",
    "broadcast_2514": "لطفاً طبق برنامه فرار از آتش از درب اضطراری و درب آتش‌سوزی به مکان امن پناه ببرید.",
    "broadcast_2006": "دستگاه پیدا نشد",
    "broadcast_2": "خدمات دیسک غیرعادی است",
    "broadcast_2515": "دستگاه‌هایی که قابلیت پخش ندارند را انتخاب کنید",
    "broadcast_2516": "فایل‌هایی که از حداکثر وضوح پشتیبانی‌شده NMP بیشتر هستند را انتخاب کنید",
    "broadcast_2517": "فایل‌هایی که از حداکثر وضوح پشتیبانی‌شده NDP500 بیشتر هستند را انتخاب کنید",
    "broadcast_Title": "هشدار پخش.",
    "broadcast_TitleNDP500": "هشدار پخش NDP500",
    "broadcast_content": "دستگاه تا 4K@30FPS را پشتیبانی می‌کند و وضوح بهینه آن 1080P@30FPS است.",
    "broadcast_contentNDP500": "NDP500/600 تا 1080P@30FPS را پشتیبانی می‌کند و وضوح بهینه آن 720P@30FPS است.",
    "broadcast_noSupported": "ویدیوهای انتخاب شده زیر برای پخش پشتیبانی نمی‌شوند:",
    "broadcast_noSupportedNDP500": "ویدیوهای انتخاب شده زیر برای پخش در NDP500/600 پشتیبانی نمی‌شوند:"
  },
  "resources": {
    "uploadNameLengthError": "نام فایل نباید از 100 کلمه بیشتر باشد!",
    "onUploadFile": "فایلی برای بارگذاری وجود ندارد",
    "open": "باز کردن",
    "fold": "جمع کردن",
    "close": "بستن",
    "PublicCloud": "ذخیره‌سازی عمومی",
    "IndividualCloud": "ذخیره‌سازی شخصی",
    "TransfersHistory": "تاریخچه انتقال",
    "btnDownload": "دانلود",
    "btnDelete": "حذف",
    "btnUploadFile": "بارگذاری فایل",
    "btnNewFolder": "پوشه جدید",
    "btnBake": "بازگشت به صفحه قبلی",
    "coxAll": "همه",
    "uploadError": "اندازه فایل بارگذاری‌شده نمی‌تواند بیشتر از 1 گیگابایت باشد!",
    "MD5": "تأیید MD5",
    "merge": "ادغام",
    "transcoding": "تبدیل",
    "uploadFailed": "بارگذاری ناموفق",
    "fileError": "خطای خواندن فایل، لطفاً فایل را بررسی کنید.",
    "tableName": "نام",
    "tableSize": "اندازه",
    "tableType": "نوع",
    "tableTimeAdded": "زمان اضافه شدن",
    "tableAction": "عملیات",
    "btnRename": "تغییر نام",
    "btnMoveTo": "انتقال به...",
    "ClearAll": "پاک کردن همه",
    "cancel": "لغو",
    "confirm": "تأیید",
    "save": "ذخیره",
    "addSuccess": "اضافه شد!",
    "addError": "اضافه کردن ناموفق!",
    "editSuccess": "ویرایش موفقیت‌آمیز!",
    "editError": "ویرایش ناموفق!",
    "delSuccess": "حذف موفقیت‌آمیز!",
    "delError": "حذف ناموفق!",
    "diskError3000": "حجم کل فضای مصرفی بیشتر از حد مجاز، عملیات ناموفق!",
    "diskError3001": "حجم فضای عمومی مصرفی بیشتر از حد مجاز، عملیات ناموفق!",
    "diskError3002": "حجم فضای فردی مصرفی بیشتر از حد مجاز، عملیات ناموفق!",
    "diskError3003": "داده‌ها پیدا نشد، لطفاً بررسی کنید که آیا سرور رسانه‌ای متصل است یا خیر!",
    "diskError3004": "نام پوشه قبلاً وجود دارد!",
    "diskError3005": "گرفتن پوشه ناموفق بود!",
    "diskError3006": "در همان سطح نمی‌توان بیشتر از 99 پوشه ایجاد کرد!",
    "diskError3007": "نام فایل یکسان است و ویرایش ناموفق بود!",
    "diskError3008": "نام پوشه یکسان است و ویرایش ناموفق بود!",
    "diskError3009": "فایل از فضای باقی‌مانده بیشتر است و بارگذاری ناموفق بود!",
    "diskError3010": "بارگذاری ناموفق بود!",
    "diskError3011": "تأیید فایل ناموفق بود، لطفاً فایل را دوباره بارگذاری کنید!",
    "diskError3012": "گرفتن آدرس فضای ابری خصوصی ناموفق بود، عملیات ناموفق!",
    "diskError3013": "ترکیب چند فایل نمی‌تواند بیشتر از 100 مگابایت باشد، لطفاً فایل‌های بزرگ را جداگانه دانلود کنید!",
    "diskError3014": "فشرده‌سازی ناموفق بود، لطفاً فایل را برای دانلود دوباره انتخاب کنید!",
    "diskError3015": "برای انجام این عملیات به مجوز نیاز دارید",
    "downloadError": "دانلود ناموفق بود!",
    "mobileError": "انتقال ناموفق بود!",
    "root": "همه فایل‌ها",
    "Name": "نام",
    "Size": "اندازه",
    "Type": "نوع",
    "uploadFile": "بارگذاری فایل",
    "newFolder": "پوشه جدید",
    "tableTime": "زمان",
    "permission": "مجوز کافی نیست!",
    "notifyTitle": "اطلاعیه",
    "notifyContent": "کاربر مجوز کافی برای دسترسی ندارد!",
    "sortFileName": "نام فایل",
    "sortTime": "زمان",
    "sortSize": "اندازه",
    "sortType": "نوع",
    "moveTo": "انتقال به",
    "test": "جدید",
    "delTitle": "حذف؟",
    "delTitleContent": "محتوای انتخاب‌شده از پایگاه داده حذف خواهد شد. این عملیات قابل برگشت نیست. آیا مطمئنید که می‌خواهید ادامه دهید؟",
    "delCancelButton": "لغو",
    "delConfirmButton": "تأیید"
  },
  "userMge": {
    "userName": "نام کاربری:",
    "jobNumber": "شناسه کارمند:",
    "email": "ایمیل:",
    "phone": "تلفن:",
    "group": "گروه:",
    "oldPassword": "کلمه عبور قدیمی:",
    "newPassword": "کلمه عبور جدید:",
    "confirmNewPassword": "تأیید کلمه عبور جدید:",
    "btnSave": "ذخیره تغییرات",
    "titleChangePassword": "تغییر کلمه عبور",
    "titleMyProfile": "پروفایل من",
    "name": "نام مستعار:",
    "error1400": "حساب (سفارشی) قبلاً وجود دارد، عملیات ناموفق بود!",
    "error1401": "حساب (تولید سیستم) قبلاً وجود دارد، عملیات ناموفق بود!",
    "error1402": "گروه وجود ندارد، وارد کردن شکست خورد!",
    "error1403": "خطای داده",
    "error1404": "مجوز کافی نیست",
    "selUser": "لطفاً یک کاربر را انتخاب کنید!",
    "error1405": "دریافت نقش ناموفق بود",
    "error1406": "فرمت اطلاعات کاربر وارد شده اشتباه است",
    "error1407": "ایمیل قبلاً وجود دارد و عملیات ناموفق بود.",
    "error1408": "تلفن قبلاً وجود دارد و عملیات ناموفق بود.",
    "editSuccess": "با موفقیت ذخیره شد!",
    "ChangePassword": "تغییر کلمه عبور",
    "UserPrivacyAgreement": "سیاست حفظ حریم خصوصی کاربر"
  },
  "information": {
    "_2602": "دستگاه آفلاین است",
    "_2603": "پخش ناموفق بود",
    "_2604": "پخش قطع شده است",
    "_2605": "فضای ذخیره‌سازی پر است",
    "_2606": "چند دقیقه پیش",
    "_2607": "چند ساعت پیش",
    "_2609": "ناموفق، لطفاً",
    "_2609_a": "اینجا کلیک کنید",
    "_2609_time": "تا در زمان مناسب اقدام کنید",
    "userType": "مدیر سیستم",
    "unreadNoticeFirst": "اطلاعیه‌های خوانده نشده ابتدا",
    "sortByTime": "مرتب‌سازی بر اساس زمان",
    "coxRead_1": "خوانده شده",
    "coxRead_0": "خوانده نشده",
    "allCoxRead": "علامت‌گذاری همه به عنوان خوانده شده",
    "load": "در حال بارگذاری...",
    "noData": "داده‌ای بیشتر موجود نیست",
    "viewALLMessages": "نمایش تمام پیام‌ها"
  },
  "input": {
    "select": "لطفاً انتخاب کنید",
    "thisField": "این فیلد باید پر شود.",
    "titleShooleNub60": "کمتر از 60 حرف",
    "titleShooleNub300": "کمتر از 300 حرف",
    "Offline": "آفلاین"
  },
  "schedule": {
    "OnlyManual": "فقط دستی",
    "runStartNow": "اجرای وظیفه",
    "runStopNow": "توقف وظیفه",
    "tackExecutionStart": "وظیفه در حال اجراست",
    "tackExecutionStop": "اجرای وظیفه متوقف شد",
    "dehumidification": "رطوبت زدایی",
    "airSupply": "تأمین هوا",
    "masterControl": "اصلی:",
    "powerSupply": "قدرت",
    "lockScreen": "قفل",
    "RecordingControl": "کنترل ضبط",
    "RecordingControlSystem": "سیستم ضبط سخنرانی",
    "LiquidCrystal": "نمایشگر LCD تعاملی",
    "projector": "پروژکتور",
    "othertype": "دیگر",
    "childLock": "قفل کودک",
    "energySaving": "صرفه جویی در انرژی",
    "signalSourceSwitching": "منبع ورودی",
    "other": "ویژگی‌های دیگر:",
    "otherFunction": "عملکرد",
    "send": "ارسال",
    "ON": "روشن",
    "OFF": "خاموش",
    "btnAddSchedule": "بازنشانی",
    "EditSchedulelist": "ویرایش برنامه‌ریز",
    "AddSchedulelist": "اضافه کردن برنامه‌ریز",
    "RestoreSchedulelist": "بازنشانی",
    "btn": "لغو",
    "btnNewList": "برنامه‌ریز جدید",
    "ListName": "نام",
    "Cannotquit": "الزامی",
    "NOCannotquit": "خیر",
    "ListValidityPeriod": "دوره اعتبار",
    "ListDescription": "توضیحات",
    "currentSchedule": "لیست برنامه‌ریزها",
    "historySchedule": "لیست تاریخچه",
    "selectTime": "زمان",
    "selectTimeTable": "زمان",
    "taskType": "نوع وظیفه",
    "selectBroadcasting": "پخش",
    "selectDeviveControl": "کنترل دستگاه",
    "newSchedule": "وظیفه جدید",
    "newChecklist": "چک‌لیست جدید",
    "titleStatus": "وضعیت",
    "titleType": "نوع",
    "titleStartTime": "زمان شروع",
    "titleEndTime": "زمان پایان",
    "titleRepeat": "تکرار",
    "titleName": "نام",
    "titleAction": "عملکرد",
    "tableEnabled": "فعال",
    "tablePaused": "معلق",
    "tableEdit": "ویرایش",
    "tableDelete": "حذف",
    "tableVolumeEdit": "حجم پخش",
    "tableBroadcastTitle": "عنوان",
    "tableBroadcastContent": "محتوا",
    "tableBroadcastList": "لیست",
    "tableBroadcast": "الزامی",
    "btnRemoveCompletely": "حذف کامل",
    "btnEnabled": "وظیفه فعال",
    "btnPaused": "غیرفعال کردن وظیفه",
    "btnDelete": "حذف",
    "repeat0": "دوشنبه",
    "repeat1": "سه‌شنبه",
    "repeat2": "چهارشنبه",
    "repeat3": "پنج‌شنبه",
    "repeat4": "جمعه",
    "repeat5": "شنبه",
    "repeat6": "یک‌شنبه",
    "dialogTitleAdd": "وظیفه جدید کنترل دستگاه",
    "dialogTitleEdit": "ویرایش وظیفه کنترل دستگاه",
    "newBroadcastingSchedule": "وظیفه جدید پخش",
    "editBroadcastingSchedule": "ویرایش وظیفه پخش",
    "chooseDevice": "انتخاب دستگاه",
    "timeSetting": "تنظیم زمان",
    "controlBroadcasting": "گزینه پخش",
    "controlOption": "گزینه کنترل",
    "scheduleName": "نام وظیفه:",
    "destination": "مقصد",
    "timeTilte": "زمان",
    "repeatTitle": "تکرار",
    "dialogRepeat0": "دوشنبه",
    "dialogRepeat1": "سه‌شنبه",
    "dialogRepeat2": "چهارشنبه",
    "dialogRepeat3": "پنج‌شنبه",
    "dialogRepeat4": "جمعه",
    "dialogRepeat5": "شنبه",
    "dialogRepeat6": "یک‌شنبه",
    "dialogOnceType": "یک‌بار",
    "dialogRepeatType": "تکرار",
    "Manual": "دستی",
    "ManualContent": "شما می‌توانید این وظایف را به صورت دستی پس از اتمام پیکربندی اجرا کنید.",
    "mainPower": "قدرت اصلی",
    "powerControl": "کنترل قدرت",
    "tableDisplayInputSwitch": "سوئیچ ورودی نمایشگر",
    "tableAirConditioning": "کولر گازی",
    "tableProjectionScreen": "صفحه پروجکشن",
    "tableElectronicLock": "قفل الکتریکی",
    "interactiveFlatPanel": "پنل تخت تعاملی",
    "displayInputSwitch": "سوئیچ ورودی نمایشگر",
    "speakerVolume": "حجم صدا",
    "MICVolume": "حجم میکروفن",
    "ProjectionScreen": "صفحه پروجکشن",
    "ElectronicLock": "قفل الکتریکی",
    "AirConditioning": "کولر گازی",
    "AirConditioningPower": "قدرت",
    "AirConditioningModel": "مدل",
    "AirConditioningTEMP": "دما",
    "AirConditioningFanSpeed": "سرعت فن",
    "OPEN": "باز",
    "CLOSE": "بسته",
    "UP": "بالا",
    "DOWN": "پایین",
    "PowerOFF": "خاموش",
    "PowerON": "روشن",
    "ModelAuto": "اتوماتیک",
    "ModelCool": "خنک کننده",
    "ModelHeat": "گرم کننده",
    "ModelAir": "کنار هوایی",
    "TEMPLow": "پایین",
    "TEMPMiddle": "متوسط",
    "TEMPHigh": "بالا",
    "btnSave": "ذخیره",
    "btnNext": "بعدی",
    "StartTime": "زمان شروع",
    "StopTime": "زمان توقف",
    "Mandatory": "الزامی",
    "Video": "ویدیو و صدا",
    "Notification": "اطلاع رسانی",
    "btnFile": "انتخاب یک فایل رسانه‌ای",
    "LastingTime": "زمان باقی‌مانده",
    "textTitle": "عنوان",
    "textContent": "محتوا",
    "textTitleLetters": "کمتر از 60 حرف",
    "textContentLetters": "کمتر از 320 حرف",
    "CannotquitYES": "بله",
    "CannotquitNo": "خیر",
    "YES": "بله",
    "No": "خیر",
    "delTitleContent": "آیا مطمئن هستید که می‌خواهید این زمانبندی را حذف کنید؟",
    "delTitleListContent": "زمانبندی حذف شده به لیست تاریخچه منتقل خواهد شد و قابل بازیابی است",
    "deleListTitle": "آیا زمانبندی را حذف می‌کنید؟",
    "delTitleListContent1": "حذف زمانبندی باعث پاک شدن وظایف مرتبط با آن خواهد شد، لطفاً تأیید کنید.",
    "deleListTitle1": "آیا مطمئن هستید که می‌خواهید این زمانبندی را حذف کنید؟",
    "delTitle": "حذف؟",
    "btnConfirm": "تأیید",
    "coxAll": "همه",
    "coxBroadcasting": "پخش",
    "coxDeviveControl": "کنترل دستگاه",
    "rdMandatory": "بله",
    "noRdMandatory": "نه",
    "startDate": "تاریخ شروع",
    "endedDate": "تاریخ پایان",
    "or": "-",
    "broadcastingType": "نوع",
    "ChooseTime": "انتخاب زمان",
    "ChooseDate": "انتخاب تاریخ",
    "newScheduleList": "زمانبندی جدید",
    "editScheduleList": "ویرایش زمانبندی",
    "listName": "نام",
    "listValidityPeriod": "دوره اعتبار",
    "listDescription": "توضیحات",
    "cancel": "لغو",
    "confirm": "تأیید",
    "save": "ذخیره",
    "addSuccess": "با موفقیت اضافه شد!",
    "addError": "اضافه کردن ناموفق بود!",
    "editSuccess": "ویرایش با موفقیت انجام شد!",
    "editError": "ویرایش ناموفق بود!",
    "delSuccess": "حذف با موفقیت انجام شد!",
    "delError": "حذف ناموفق بود!",
    "restoreSuccess": "لیست زمانبندی‌ها با موفقیت بازیابی شد",
    "restoreError": "بازیابی لیست زمانبندی‌ها ناموفق بود",
    "restoreTitleContent": "این زمان با زمانبندی‌های موجود در لیست تداخل دارد، لطفاً دوباره انتخاب کنید",
    "Enabled": "فعال",
    "Paused": "معلق",
    "Title": "عنوان:",
    "Content": "محتوا:",
    "errorScheduleNameRequired": "نام وظیفه باید پر شود",
    "errorDeviceRequired": "لطفاً دستگاه هدف را انتخاب کنید",
    "deleTitle": "آیا مطمئن هستید که می‌خواهید این وظیفه را حذف کنید؟",
    "loopList": "لیست تکرار",
    "errorPleaseDateRange": "لطفاً یک بازه زمانی انتخاب کنید",
    "addError_2009": "نام تکراری زمانبندی",
    "conflicts": "زمان وظیفه با موارد زیر تداخل دارد:",
    "Pleaseagain": "لطفاً دوباره وارد کنید",
    "errorScheduleName": "نام وظیفه",
    "errorListName": "نام زمانبندی",
    "today": "امروز",
    "yesterday": "دیروز",
    "thisWeek": "این هفته",
    "lastWeek": "هفته گذشته",
    "lastMonth": "ماه گذشته",
    "thisMonth": "این ماه",
    "times": "دفعات",
    "TimeConflicts": "تداخل زمانی",
    "editError_2006": "دستگاه پیدا نشد",
    "editError_2010": "نام تکراری وظیفه",
    "editError_2100": "این وظیفه منقضی شده است و نمی‌توان آن را شروع کرد.",
    "ListTimeExpired": "زمان زمانبندی منقضی شده است، لطفاً دوباره انتخاب کنید",
    "TimeExpired": "زمان منقضی شد",
    "ControlOption": "گزینه کنترل موجود نیست",
    "Pleaseleastone": "لطفاً حداقل یک گزینه کنترل انتخاب کنید",
    "Enter": "وارد کردن",
    "TitleFilled": "عنوان باید پر شود",
    "ContentFilled": "محتوا باید پر شود",
    "PleaseMediaFile": "لطفاً یک فایل رسانه‌ای انتخاب کنید",
    "PleaseSchedule": "لطفاً یک وظیفه انتخاب کنید",
    "delTitleScheduleContent": "وظیفه حذف شده قابل بازیابی نیست.",
    "deleTitleSchedule": "آیا مطمئن هستید که می‌خواهید این وظیفه را حذف کنید؟",
    "deleteScheduleTitle": "لطفاً وظیفه‌ای که می‌خواهید حذف کنید را انتخاب کنید",
    "PleaseFillColumn": "لطفاً نام زمانبندی را پر کنید",
    "PleaseDate": "لطفاً تاریخ را انتخاب کنید",
    "Previous": "قبلی",
    "RemoteControl": "کنترل از راه دور",
    "taskhasexpired": "این وظیفه منقضی شده است، لطفاً با ایجادکننده تماس بگیرید تا زمان را بروزرسانی کند.",
    "execute": "اجرای وظیفه",
    "broadcastingList": "لیست پخش",
    "volumeSuccess": "تنظیم حجم صدا با موفقیت انجام شد",
    "volumeFailed": "تنظیم حجم صدا با شکست مواجه شد"
  },
  "live": {
    "StreamingRoom": "اتاق استریم",
    "btnAddNewRoom": "افزودن اتاق جدید",
    "Steaming": "استریمینگ",
    "Creater": "میزبان:",
    "Address": "آدرس RTMP:",
    "StreamingURL": "URL استریم زنده:",
    "DestinationNMP": "انتخاب مقصد NMP:",
    "stop": "توقف",
    "stat": "شروع",
    "btnCope": "برای کپی کردن کلیک کنید",
    "QRcode": "کد QR",
    "Refresh": "به‌روزرسانی",
    "AddNewRoomTitle": "افزودن اتاق استریم جدید",
    "editNewRoomTitle": "ویرایش اتاق استریم",
    "roomName": "نام اتاق:",
    "cancel": "لغو",
    "confirm": "تایید",
    "save": "ذخیره",
    "delTitleContent": "آیا مطمئن هستید که می‌خواهید این برنامه را حذف کنید؟",
    "delTitle": "حذف؟",
    "delCancelButton": "لغو",
    "delConfirmButton": "تایید",
    "addSuccess": "با موفقیت اضافه شد!",
    "addError": "اضافه‌سازی با شکست مواجه شد!",
    "editSuccess": "ویرایش با موفقیت انجام شد!",
    "editError": "ویرایش با شکست مواجه شد!",
    "delSuccess": "حذف با موفقیت انجام شد!",
    "delError": "حذف با شکست مواجه شد!",
    "Stopstreaming": "توقف استریم",
    "Startstreaming": "شروع استریم",
    "error2504": "نمی‌توان آدرس استریم زنده سرور رسانه را دریافت کرد",
    "error2505": "نام اتاق استریم تکراری است",
    "error2506": "دستگاه توسط سیگنال استریم دیگری اشغال شده است",
    "error1900": "پارامتر وارد شده خالی است",
    "error2503": "نمی‌توان اطلاعات سرور رسانه را دریافت کرد",
    "error2507": "آدرس استریم زنده تکراری است",
    "copySuccess": "محتوا به کلیپ بورد کپی شده است.",
    "copyError": "مرورگر از کپی خودکار پشتیبانی نمی‌کند",
    "flashControl": "فلش نصب یا فعال نشده است. لطفاً پس از نصب یا فعال‌سازی فلش دوباره تلاش کنید.",
    "liveStreaming": "منبع استریم زنده پیدا نشد.",
    "btnflash": "نصب/فعال‌سازی",
    "serverAddress": "آدرس سرور",
    "addressKey": "کلید:",
    "watchingAddress": "آدرس تماشا",
    "audioOnly": "فقط صدا",
    "enterTheKey": "کلید باید پر شود."
  },
  "guidepages": {
    "next": "بعدی – کنترل دستگاه",
    "next1": "بعدی – تلاش برای کنترل",
    "next2": "بعدی – پخش",
    "next3": "بعدی – شروع پخش",
    "next4": "بعدی – توقف پخش",
    "next5": "بعدی – پخش متنی",
    "next6": "بعدی – تنظیمات وظیفه",
    "next7": "بعدی – افزودن وظیفه جدید",
    "next8": "بعدی – لیست تاریخچه",
    "next9": "بعدی – ذخیره‌سازی ابری",
    "next10": "بعدی – استریم زنده",
    "next11": "بعدی – تنظیم استریم زنده",
    "exit": "خروج",
    "guideContent": "محتوای راهنما",
    "btnHomepage": "صفحه اصلی",
    "btnDevices": "دستگاه‌ها",
    "btnBroadcast": "پخش",
    "btnSchedule": "برنامه‌ریزی",
    "btnResources": "منابع",
    "btnStreaming": "استریم",
    "btnPrevious": "قبلی"
  },
  "privacy": {
    "PrivacyPolicy": "Q-NEX Privacy Policy",
    "Byusing": "By using the Q-NEX service, you are trusting us to process your information. We understand that this responsibility is important, so we have been committed to protecting your information and giving you control.",
    "whatinformation": "This Privacy Policy is designed to help you understand what information we collect, why it is collected, and how you manage your information.",
    "EffectiveDate": "Effective Date: January 1, 2020",
    "title1": "Q-NEX Respects Your Privacy",
    "title1Respects1": "Returnstar Interactive Technology Group Co.,Ltd. and its sub-brand (collectively “Q-NEX”, “we” or “us”) respect your privacy and understand that the processing and security of your personal data is important to you. Please review the full Privacy Policy below for more complete details on how we collect, use, share, and protect your personal data, as well as the choices you have regarding our use and sharing of your personal data, along with other important considerations.",
    "title1Respects2": "This Privacy Policy explains Q-NEX’s practices regarding the processing (such as the collection, use, storage, copy or disclosure) of your personal data received: (i) through our website https://www.qnextech.com (“Website”), email, and other written or in person communications; (ii) in the context of all our commercial relations with customers, end-users, dealers, distributors, suppliers, contractors, agents or representatives; and (iii) in the normal course of any other potential business relationship. We commit to comply with our obligations under all applicable Privacy and Data Protection Laws, as described below, including but not limited to the Provisions on Protection of Personal Information of Telecommunications and Internet Users, and to respect your rights whenever we are processing your personal data.",
    "title2": "Privacy and Data Protection",
    "title2Respects1": "“Personal Data” means any information that identifies, or can be used to identify, an individual.",
    "title2Respects2": "“Privacy and Data Protection Laws” means any and/or all laws, rules, directives and regulations, on any local, provincial, state, federal or national level within and outside the People's Republic of China, pertaining to data privacy, data security and/or the protection of Personal Data. Among them, laws and regulations outside China include but not limited to: (a) the General Data Protection Regulation (GDPR) and each European Union Member States’ national implementation thereof; (b) the Australian Privacy Act 1988 (Cth) and the Australian Privacy Amendment (Enhancing Privacy Protection Act) (2012); (c) the Belgian Privacy Law of 8 December 1992; (d) the Canadian Personal Information Protection and Electronic Documents Act, SC 2000, c 5 (PIPEDA); (e) the Personal Data Protection Act 2012 of Singapore (PDPA); (f) additional privacy and data protection laws applicable to a data subject’s location; and (g) any successor legislation or regulations applicable thereto.",
    "title3": "When Do We Collect Your Personal Data?",
    "title3Respects1": "Q-NEX may collect your personal data when you communicate with us by phone, e-mail, the Website or otherwise, in the context of:",
    "title3a": "Browsing our Website or visiting our social media sites;",
    "title3b": "Corresponding with Q-NEX;",
    "title3c": "Visiting one of our offices, events or facilities;",
    "title3d": "Registering for and/or participating in our conferences, events, training or other activities;",
    "title3e": "Requesting information, support, service, materials, assistance or other inquiries;",
    "title3f": "Subscribing to a newsletter or other mailing list;",
    "title3g": "Exchanging business cards;",
    "title3h": "Completing Website contact forms, questionnaires, surveys, or contest entry forms or otherwise participating in these activities;",
    "title3i": "Engaging in commercial relationships or other collaboration;",
    "title3j": "Ordering or registering Q-NEX products;",
    "title3k": "Creating or registering an account;",
    "title3l": "Uploading or downloading files;",
    "title3m": "Verification of your identity as a data subject; or",
    "title3n": "Using Q-NEX products that are connected to the Internet, including mobile apps, cloudware, and certain hardware devices.",
    "title4": "Which Types of Personal Data are Processed by Us?",
    "title4Respects1": "Q-NEX may process the following personal data:",
    "title4a": "Name, surname, title, company, email address, phone number (mobile and landline), address, signature and other contact information;",
    "title4b": "IP addresses;",
    "title4c": "Location data;",
    "title4d": "Cookie ID;",
    "title4e": "Language;",
    "title4f": "Personal preferences regarding communications and/or products and services;",
    "title4g": "Financial details (e.g. payment information, bank account number, and credit information);",
    "title4h": "Personal data regarding projects using Q-NEX products and services;",
    "title4i": "Personal data provided in your submissions, responses and feedback;",
    "title4j": "Personal data regarding your interactions with Q-NEX, including your use of the Website and of Q-NEX’s products or services;",
    "title4k": "Social media data, images, photos, and camera footage; and",
    "title4l": "Any other personal data provided by you or by your authorized Q-NEX dealer or service provider.",
    "title4Respects2": "For the avoidance of doubt, Q-NEX does not collect any sensitive personal data, such as racial or ethnic origin; political opinions; religious or philosophical beliefs; genetic characteristics; health information; sexual preferences; information about children; criminal convictions; or biometric data, and we explicitly ask that you not provide us with such data in your responses or feedback to us.",
    "title5": "How Do We Use Your Personal Data?",
    "title5Respects1": "In order to better manage our own business needs and to better communicate with you, we may collect, analyze, use and otherwise process your personal data for the following purposes:",
    "title5a": "To respond to your inquiries, questions and other requests;",
    "title5b": "To optimize and manage the quality and content of our Website, including the ability to personalize and secure your Website experience;",
    "title5c": "To create and maintain your website, customer and product accounts and registrations;",
    "title5d": "To provide you with marketing, advertising, promotions, programs, offers and other opportunities; including newsletters, information on products and services, subscriptions, training, updates and direct marketing, which may be targeted, based on your communication preferences;",
    "title5e": "To conduct customer satisfaction studies, surveys and other market research;",
    "title5f": "To manage our events and activities, and invite you to events;",
    "title5g": "To register visitors to our offices, facilities and events;",
    "title5h": "To create promotional materials, including videos, photos, articles, case studies, newsletters and other materials regarding projects or events;",
    "title5i": "To provide products, services, training, technical support, customer service and other assistance;",
    "title5j": "To manage and perform our agreements and obligations;",
    "title5k": "To respond to and follow up on business leads, opportunities, and contacts;",
    "title5l": "To process payments, orders, invoicing, returns, collection and other requests;",
    "title5m": "To provide pricing, quotations and custom configurations of our products and services;",
    "title5n": "To grant you access to our software, training, technical information and other proprietary content;",
    "title5o": "To evaluate, troubleshoot, analyze and improve the use, functionality, features, and performance of our products, services, training, technical support and customer service;",
    "title5p": "To gather, analyze and maintain configuration and backup data regarding our products and services;",
    "title5q": "To facilitate planning, analytics, forecasting and reporting regarding our products and services;",
    "title5r": "To use for our internal business operations and processes, including business and financial recordkeeping, data management and business continuity; and",
    "title5s": "To meet our legal and regulatory obligations.",
    "title6": "Which Legal Basis Applies To Our Processing Of Your Personal Data?",
    "title6Respects1": "The following legal grounds might apply to the processing of your personal data for the purposes mentioned above:",
    "title6a": "Processing is necessary for the performance of your agreement with us or in order to take all pre-contractual steps;",
    "title6b": "Processing takes place based upon our legitimate interest (comply with obligations, maintain business records, fraud prevention, network and information security, etc.). When carrying out this type of processing, we strive to strike a balance between this legitimate interest and respect for your privacy;",
    "title6c": "You have given your consent to the processing (e.g. in case of direct marketing, for the processing of analytic cookies and for data transfers to third parties);",
    "title6d": "In order to comply with our legal obligations (such as tax administration and record retention); or",
    "title6e": "In very exceptional circumstances to protect your vital interest or that of someone else.",
    "titel7": "To Whom Do We Disclose Your Personal Data?",
    "title7Respects1": "Q-NEX may disclose your personal data to yourself, to Q-NEX’s affiliates or to third parties, such as payment providers, software providers, cloud partners, transport partners, financial institutions, insurance companies, legal services, or certain other service providers or partners that Q-NEX has a strategic relationship with, in order to fulfill our relationship with you in the most effective way.",
    "title7Respects2": "Q-NEX will not disclose to third parties any personal data you submit for purposes other than those described in this Privacy Policy. If, in the future, we intend to disclose your personal data to third parties for any purpose other than those described in this Privacy Policy we shall inform you thereof in advance and ask your consent if required.",
    "title7Respects3": "Notwithstanding the foregoing, Q-NEX will disclose your personal data to a third party (such as competent authorities) if required to do so by law, during a legal proceeding, or if, in good faith, Q-NEX believes that such action is necessary to comply with certain laws, rules or regulations.",
    "titel8": "Which Guarantees Do We Provide in Case of International Data Transfers?",
    "title8Respects1": "Q-NEX is a global company and we may transfer your information to Q-NEX affiliates, representatives or third party contractors who represent us worldwide. Each affiliate, representative, or third party contractor works closely with Q-NEX, and any transfer of personal data between these associated entities will comply with applicable Privacy and Data Protection Laws.",
    "title8Respects2": "If any transfer of the personal data of residents of the European Economic Area (EEA) is made to a person or entity located in a country outside of the EEA, that is not recognized as providing an adequate level of protection, we will provide for increased information security and appropriate contractual provisions to strengthen data protection. To ensure that any such transfers of the personal data of EEA residents are compliant with the applicable Privacy and Data Protection Laws, we will either (i) conclude a data transfer agreement, based upon the EU model agreements, (ii) adopt binding corporate rules, (iii) rely on legally determined exceptions (such as requesting your explicit consent) or (iv) adopt other mechanisms which have been deemed to provide for the adequate protection of your personal data.",
    "titel9": "How Do We Secure Your Personal Data?",
    "title9Respects1": "We use a variety of security technologies and precautions, such as the Secure Socket Layer (SSL) protocol (encryption), to help protect your personal data from loss, theft, misuse and unauthorized access, in accordance with industry standards. To protect any personal data stored on Q-NEX servers or cloud-based storage, we regularly monitor our systems for vulnerabilities or attacks, and implement up to date information security measures.",
    "title9Respects2": "Access to personal data that is processed by Q-NEX is limited only to those of its employees, contractors and affiliated organizations that need to know that information in order to process it on Q-NEX’s behalf, in accordance with this Privacy Policy, and that have agreed not to disclose it to others.",
    "titel10": "How Long Do We Retain Your Personal Data?",
    "title10Respects1": "Unless a longer retention period is required by law, Q-NEX will retain your personal data for as long as needed to fulfil the relevant purposes described in this Privacy Policy.",
    "titel11": "Use of Cookies",
    "title11Respects1": "Q-NEX uses cookies on our Website, both to enable the site to work properly, and to enhance your experience while visiting our Website. Cookie file(s), which are stored on the hard drive of your computer, enable us to obtain information about your usage of our Website, and to measure and improve the performance of our Website. Cookies enable you to store your preferences, in order to enable our Website to recognize these preferences when you browse our Website.",
    "title11Respects2": "You may refuse to accept cookies by activating the setting on your browser which allows you to refuse cookies. However, if you select this setting you may not be able to access certain sections or features of our Website. Unless you have adjusted your browser setting so that it will refuse cookies, our system will issue cookies to your computer whenever you log on to our Website.",
    "title11Respects3": "When you visit our Website for the first time you will be provided with a link to this cookie policy and will have the opportunity to change your browser settings to refuse cookies. By continuing to browse our website without changing your settings, you agree to our use of cookies as explained in this policy.",
    "title11Respects4GoogleAnalytics": "Google Analytics.",
    "title11Respects4": "We use industry standard web analytics to track visits to our sites, namely those provided by Google Analytics. The information generated by the cookies about your use of our Website (including your IP address) will be transmitted to and stored by Google Analytics on their servers and is handled in accordance with Google’s Privacy Policy which can be accessed at the following link: https://policies.google.com/privacy.",
    "titel12": "Third Party Links on our Website",
    "title12Respects1": "The Website contains links to other websites. Q-NEX is not responsible for the privacy policy of other websites, or the manner in which they store, use or distribute information. Q-NEX encourages you to review the privacy policy of any website you may visit.",
    "titel13": "Children’s Information",
    "title13Respects1": "Q-NEX’s Website is not intended for use by children, and its products and services are not sold to children. In accordance with the Children’s Online Privacy Protection Act, we do not collect or maintain information from persons we know are under 18, and no part of the Website is designed to attract anyone under age 18.",
    "titel14": "What Are Your Rights and How Can You Exercise Them?",
    "title14Respects1": "If you are a natural person, you have the right at all times to be informed about the personal data we process about you, and to the extent authorized under the applicable Privacy and Data Protection Laws, to request access, modification, limitation of processing, transfer or deletion of personal data, or to object to the processing of your personal data, subject to the exceptions within the applicable Privacy and Data Protection Laws.",
    "title14Respects2": "If processing is based solely on your consent, you also have the right to revoke your consent at any time, without prejudice to the lawfulness of processing prior to revocation.",
    "title14Respects3": "Through the contact options listed below, you can exercise the above rights regarding the processing of your personal data by Q-NEX, except in cases where this would require a disproportionate effort on the part of Q-NEX.",
    "title14Respects4": "Please feel free to use the contact information listed below if you have any additional concerns regarding your personal data or your exercise of the above rights, and we will do our best to assist you.",
    "title14Respects5": "If you contact us to exercise one of your rights under the applicable Privacy and Data Protection Laws, we will reply within one (1) month. In certain exceptional circumstances, we may take up to three (3) months to fully respond to you, but in such case we shall inform you why we require additional time to respond in our initial reply.",
    "title14Respects6": "If we are unable to resolve an inquiry or request, where applicable, you may have the right to lodge a complaint with the local data protection authority.",
    "titel15": "Stay Informed of Changes in Our Privacy Policy",
    "title15Respects1": "In a world in which technology and legislation is constantly changing, this Privacy Policy may also change. We invite you to always consult the latest version of this policy, posted at https://www.qnextech.com/legal, and we will inform you of any changes via our Website or other common communication channels.",
    "titel16": "Contact Q-NEX",
    "title16Respects1": "If you have questions and/or comments about this Privacy Policy or the manner in which Q-NEX collects, uses and/or processes your personal data, please contact us:",
    "title16Respects2": "Via e-mail: info@qnextech.com"
    	}
}



// WEBPACK FOOTER //
// ./src/lang/fa.js